<aside class="sidebar bg-sidebar" id="sidebar">
  <ul class="sidebar-nav">
      <li class="nav-item">
          <a class="nav-link" routerLink="/home" [ngClass]="{'active': selectedItemIndex === 1}" (click)="selectItem(1)">
              <span>{{lang?.Overview}}</span>
          </a>
      </li>
      <li class="nav-item" *ngIf="!waddelCustomer && !hideLifeCiMenus ">
          <a class="nav-link collapsed" data-bs-target=".multi-collapse" data-bs-toggle="collapse" href="#"
          (click)="toggleChevron()" [ngClass]="{'active': selectedItemIndex === 2}" (click)="selectItem(2)"><span>{{lang?.My_Member_Portals}}</span>
              <i [ngClass]="{'bi-chevron-right': showChevronDown, 'bi-chevron-down': !showChevronDown,}"
                  class="ms-auto"></i></a>
          <ul id="Providers" class="nav-content collapse multi-collapse">
              <li class="nav-item navItempointer "*ngIf="!hideLifeCiMenus" data-bs-target="#dentalinsurance" data-bs-toggle="collapse" (click)="toggleChevron2()"> <a class="nav-link navlink" id="subfont" ><span >Health & Dental Insurance</span>
                  <i [ngClass]="{'bi-chevron-right': showChevronDownhealth, 'bi-chevron-down': !showChevronDownhealth,}"
                  class="ms-auto"></i>
              </a>
              </li>
              <ul id="dentalinsurance" class="nav-content collapse" [ngClass]="{'multi-collapse': !showChevronDownhealth}" *ngIf="equitablecheck=='true'">
                  <li class="nav-item navItempointer " data-bs-target="#Equitqble" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.Equitable_Life}}</span> </a></li>
              </ul>
              <ul id="dentalinsurance" class="nav-content collapse" [ngClass]="{'multi-collapse': !showChevronDownhealth}" *ngIf="greenshildcheck=='true'">
                <li class="nav-item navItempointer " data-bs-target="#Greenshild" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.Greenshield}}</span> </a></li>
            </ul>
              <li class="nav-item navItempointer " data-bs-target="#studentWellness" data-bs-toggle="collapse" (click)="toggleChevron3()" *ngIf="equitablecheck=='true'">
                <a class="nav-link navlink" id="subfont" ><span >{{lang?.Complete_Wellness}}</span>
                  <i [ngClass]="{'bi-chevron-right': showChevronDownwellness, 'bi-chevron-down': !showChevronDownwellness,}"

                  class="ms-auto"></i>
              </a>
              </li>
              <ul id="studentWellness" class="nav-content collapse ulheigh" [ngClass]="{'multi-collapse': !showChevronDownwellness}">
                  <li class="nav-item navItempointer" data-bs-target="#Alavida" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.ALAViDA}}</span> </a></li>
                  <li class="nav-item navItempointer">
                  <a class="nav-link navlink" href='https://secure.kiihealth.ca/' onclick='window.open ("https://secure.kiihealth.ca/",
"CloudMDKii","menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");return false;' ><span>{{lang?.CloudMD_Kii}}</span></a>
                  </li>
                  <li class="nav-item navItempointer" data-bs-target="#PhzioMSK360" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.Phzio_MSK360}}</span> </a></li>
                  <li class="nav-item navItempointer" data-bs-target="#RxFood" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.RxFood}}</span> </a></li>
                                    <li class="nav-item navItempointer">
                      <a class="nav-link navlink" href='https://groupbenefitz.lifespeak.com' onclick='window.open ("https://groupbenefitz.lifespeak.com",
      "LifeSpeak","menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");return false;' ><span>{{lang?.LifeSpeak}}</span></a>
                  </li>
                  <li class="nav-item navItempointer" data-bs-target="#lifeSession" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.LIFT_Session}}</span> </a></li>
                  <li class="nav-item navItempointer" data-bs-target="#SolidGroundMethod" data-bs-toggle="modal"> <a class="nav-link navlink" ><span >{{lang?.The_Solid_Ground_Method}}</span> </a></li>
              </ul>
                            <ul id="voluntarybenefits" class="nav-content collapse" [ngClass]="{'multi-collapse': !showChevronDownbenefits}">
                                </ul>
          </ul>
      </li>
      <li class="nav-item" *ngIf="!waddelCustomer">
          <a class="nav-link" [routerLink]="currClient ? ['/', currClient, 'home'] : ['/home']"  [ngClass]="{'active': selectedItemIndex === 3}" (click)="selectItem(3)">
            <span  data-bs-target="#Carequest" data-bs-toggle="modal">{{lang?.Providers_Near_me}}</span></a>
      </li>
      <!-- 05022025/updated today -->
       
      
      <li class="nav-item" id="closeModal">
        <a class="nav-link collapsed" [attr.data-target]="'#settings'"
         id="settings" data-bs-target="#forms-nav2" data-bs-toggle="collapse" href="#"
        (click)="toggleChevron5()" [ngClass]="{'active': selectedItemIndex === 5,'collapsed': selectedItemIndex != 5}" (click)="selectItem(5)"><span>{{lang?.Settings}}</span>
            <i [ngClass]="{'bi-chevron-right': showChevronSettings, 'bi-chevron-down': !showChevronSettings,}"
              class="ms-auto"></i>
        </a>
        <ul id="forms-nav2" class="nav-content collapse ulheigh">

            <li class="nav-item navItempointer" >
              <a class="nav-link navlink" id="subfont" data-bs-toggle="modal" data-bs-target="#signature" >{{lang?.Review_and_Sign_Documents}}</a>
            </li>

                </ul>
    </li>
      </ul>
</aside>






<app-update-address id="Equitqble" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [Equitqble]="Equitqble" [historyLength]="historyLength" [lang]="lang"></app-update-address>
  <app-update-address id="Greenshild" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [Greenshild]="Greenshild" [historyLength]="historyLength" [lang]="lang"></app-update-address>
<app-update-address id="Alavida" class="modal modal-xl modalposition" data-bs-backdrop="static"
  [Alavida]="Alavida" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="CloudMD" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [CloudMD]="CloudMD" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="PhzioMSK360" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [PhzioMSK360]="PhzioMSK360" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="SolidGroundMethod" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [SolidGroundMethod]="SolidGroundMethod" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="RxFood" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [RxFood]="RxFood" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="LifeSpeak" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [LifeSpeak]="LifeSpeak" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="lifeSession" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [lifeSession]="lifeSession" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="NortonLifeLock" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [NortonLifeLock]="NortonLifeLock" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="MyHsa" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [MyHsa]="MyHsa" [historyLength]="historyLength" [lang]="lang"></app-update-address>

<app-update-address id="Carequest" class="modal modal-lg modalposition" data-bs-backdrop="static"
  [Carequest]="Carequest" [historyLength]="historyLength" [lang]="lang"></app-update-address>











<div id="newletters" class="modal modal-lg modalposition" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content">
          <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title" *ngIf="headername!='ehn'">{{headername | titlecase}} {{lang?.Newsletter}}</h6>
              <h6 class="modal-title" *ngIf="headername=='ehn'">{{headername | uppercase}} {{lang?.Newsletter}}</h6>
              <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closeNewsLetters()"></i>
          </div>
          <div class="modal-body" style="overflow-y: hidden !important;">
              <div >
                <span *ngIf="loading">
                  <img src="../../assets/img/loader.gif" width="100" style=" display: block;
          margin-left: auto;
          margin-right: auto;
          width: 5%;">
              </span>
                  <pdf-viewer [src]="link" id="pdf-viewer" (after-load-complete)="pdfLoaded($event)"></pdf-viewer>
              </div>
          </div>
          <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" id="cancelButton" data-bs-dismiss="modal" (click)="closeNewsLetters()"><b>{{lang?.Close}}</b></button>
          </div>
      </div>
  </div>
</div>

<div id="signature" class="modal modal-md modalposition" data-bs-backdrop="static">
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
                <h6 class="modal-title">{{lang?.Upload_Signature}}</h6>
                <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>


        </div>
        <div class="modal-body">

          <table>
            <tr>
              <th>S.no</th>
              <th>{{lang?.Document}}</th>
              <th>{{lang?.Action}}</th>
            </tr>
            <tr *ngFor="let list of failedsignature;let i=index">
              <th scope="row">{{i+1}}</th>
              <td>
                <span *ngIf="list=='ROE'">Record of Enrollment (ROE)</span>
                <span *ngIf="list=='PAD'">Pre-Authorized Debit (PAD)</span>

              </td>
              <td> <button type="button" class="btn btn-sm btn-light"
                id="updateButton" data-bs-toggle="modal" data-bs-target="#Updatesignature"(click)="viewDocument(list)">{{lang?.View_and_Sign}}</button></td>

            </tr>

          </table>
          <div *ngIf="failedsignature.length==0">
              {{lang?.No_documents_available_for_update_signature}}
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
          id="updateButton" >{{lang?.Close}}</button>

        </div>
    </div>
</div>
</div>

<div id="signature12" class="modal fade modalposition" data-bs-backdrop="static">
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
                <h6 class="modal-title">{{lang?.Signature}}:{{clientName}}</h6>
                <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>


        </div>
        <div class="modal-body">
            <div class="signature-container">
                <signature-pad [options]="signaturePadOptions1" (onBeginEvent)="drawStart1()"
                    (onEndEvent)="drawComplete1()"></signature-pad>
            </div>
            
        </div>
        <div class="modal-footer py-2">
          <button class="btn btn-sm btn-light" id="cancelButton" [disabled]="showcancel" (click)="clearSignature()">{{lang?.Clear}}</button>

            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                id="updateButton" (click)="saveSignature()" [disabled]="showconfirm">{{lang?.Confirm}}</button>
        </div>
    </div>
</div>
</div>
<div id="drawsignature" class="modal fade modalposition" data-bs-backdrop="static">
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
                <h6 class="modal-title">{{lang?.Signature}}:{{clientName}}</h6>
                <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>


        </div>
        <div class="modal-body">
            <div class="signature-container">
                                    <canvas #sigPad width="400"   (mousedown)="onMouseDown($event)" (touchstart)="onMouseDown($event)" (touchmove)="onMouseMove($event)"
                    (mousemove)="onMouseMove($event)" height="300"></canvas>

            </div>
            
        </div>
        <div class="modal-footer py-2">
          <button class="btn btn-sm btn-light" id="cancelButton" [disabled]="showcancel" (click)="clearSignature()">{{lang?.Clear}}</button>

            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                id="updateButton" (click)="saveSignature()" [disabled]="showupdatesignatue">{{lang?.Confirm}}</button>
        </div>
    </div>
</div>
</div>

<div id="Updatesignature" class="modal fade modal-lg  modalposition" data-bs-backdrop="static">
<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
        <div class="modal-header" id="backgroundColor">
                <h6 class="modal-title"> Update Signature:{{fileName}}</h6>
                <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>


        </div>
        <div class="modal-body">
          <pdf-viewer *ngIf="filetype&&filetype!=undefined" [src]="filetype" id="pdf-viewer"></pdf-viewer>


        </div>
        <div class="modal-footer py-2">
          <button class="btn btn-sm btn-light" id="cancelButton" aria-hidden="true" data-bs-dismiss="modal">{{lang?.Close}}</button>

            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
                id="updateButton" data-bs-toggle="modal" data-bs-target="#drawsignature" >{{lang?.Signature}}</button>
        </div>
    </div>
</div>
</div>

